import CheckIcon from "./check.svg?react";

interface BranchIconProps {
  isReached?: boolean;
}

export const BranchIcon = (props: BranchIconProps) => {
  const { isReached } = props;

  return isReached ? (
    <div className="flex items-center justify-center w-[24px] h-[24px] rounded-full bg-purple-100">
      <CheckIcon className="w-[12px] h-[8px] stroke-[2px]" />
    </div>
  ) : (
    <div className="flex items-center justify-center w-[24px] h-[24px] rounded-full bg-gray-g30">
      <div className="w-[12px] h-[12px] rounded-full bg-gray-g75" />
    </div>
  );
};
